import { useState } from "react";
import { Image as RNImage, ImageStyle } from "react-native";
const DEFAULT_IMAGE = require("../../assets/image-unavailable.png");

type ImageProps = {
  imageUrl?: string;
  style?: ImageStyle;
  imageClassName: string;
};

const activityImageSource = (imageUrl?: string) => (imageUrl ? { uri: imageUrl } : DEFAULT_IMAGE);

export default function ActivityImage({ imageUrl, imageClassName, style }: ImageProps) {
  const [imageSource, setImageSource] = useState(activityImageSource(imageUrl));

  return (
    <RNImage
      source={imageSource}
      className={imageClassName}
      style={style}
      onError={() => setImageSource(DEFAULT_IMAGE)}
      testID="activity-image"
    />
  );
}
